/**
 * Environment Configuration
 * Browser-safe: no direct process.env access (webpack only replaces NODE_ENV)
 */
function envVar(name, fallback = '') {
    try {
        // webpack DefinePlugin replaces process.env.NODE_ENV; others may not exist
        const val = (typeof process !== 'undefined' && process.env && process.env[name]);
        return val || fallback;
    }
    catch {
        return fallback;
    }
}
const nodeEnv = envVar('NODE_ENV', 'production');
export const ENV = {
    // Deployment
    NODE_ENV: nodeEnv,
    IS_PRODUCTION: nodeEnv === 'production',
    IS_DEVELOPMENT: nodeEnv === 'development',
    APP_URL: envVar('VITE_APP_URL', 'https://dominauts.com'),
    APP_VERSION: '2.1.0',
    // Supabase (optional backend)
    SUPABASE: {
        URL: envVar('VITE_SUPABASE_URL'),
        ANON_KEY: envVar('VITE_SUPABASE_ANON_KEY'),
        SERVICE_ROLE_KEY: '',
        enabled: false // enable when Supabase is configured
    },
    // Stripe (optional)
    STRIPE: {
        publishableKey: '',
        webhookSecret: '',
        enabled: false
    },
    // Analytics (optional)
    ANALYTICS: {
        GA_ID: '',
        SENTRY_DSN: '',
        MIXPANEL_TOKEN: '',
        enabled: false
    },
    // Feature Flags
    FEATURES: {
        multiplayer: true,
        tournaments: false,
        ads: false,
        iap: false,
        ai: true,
        hints: true
    },
    // Game Settings
    GAME: {
        maxPlayers: 4,
        defaultMode: 'allfives',
        turnTimeout: 30000,
        maxGamesPerDay: 100
    },
    // Security
    SECURITY: {
        jwtSecret: '',
        sessionSecret: '',
        rateLimitRequests: 100,
        rateLimitWindow: 900000,
        strictRateLimit: 5
    },
    // API
    API: {
        baseUrl: '/api',
        edgeFunctionsUrl: ''
    }
};
// Type-safe config getter
export function getConfig(key) {
    return ENV[key];
}
// Validate - warn only, never throw
export function validateEnvironment() {
    const warnings = [];
    if (!ENV.SUPABASE.URL || !ENV.SUPABASE.ANON_KEY) {
        warnings.push('Supabase not configured - running in offline/guest mode');
        ENV.SUPABASE.enabled = false;
    }
    else {
        ENV.SUPABASE.enabled = true;
    }
    if (warnings.length > 0) {
        console.warn('[Dominauts] Environment:', warnings.join('; '));
    }
}
// Initialize on load (safe - never throws)
validateEnvironment();
